import { APP_CONFIG } from '@/constants/app';
import {
  UserAutomationsParams,
  UserAutomationsResponse,
} from '@/types/automation.types';
import { tokenManager } from '@/utils/token-manager';
import axios from 'axios';

// Create axios instance for user automations service
const userAutomationsApi = axios.create({
  baseURL: APP_CONFIG.api.baseUrl,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Setup automatic token refresh interceptors
tokenManager.setupInterceptors(userAutomationsApi);

export const userAutomationsService = {
  // Get all user automations with pagination and filters
  getUserAutomations: async (
    params: UserAutomationsParams = {}
  ): Promise<UserAutomationsResponse> => {
    const queryParams = new URLSearchParams();

    if (params.page) queryParams.append('page', params.page.toString());
    if (params.limit) queryParams.append('limit', params.limit.toString());
    if (params.domainUuid) queryParams.append('domainUuid', params.domainUuid);
    if (params.status) {
      if (params.status === 'active') {
        queryParams.append('status', 'active');
      } else if (params.status === 'inactive') {
        queryParams.append('status', 'inactive');
      }
    }
    if (params.search) queryParams.append('search', params.search);
    if (params.templateId) queryParams.append('templateId', params.templateId);

    const response = await userAutomationsApi.get<UserAutomationsResponse>(
      `/user/automations?${queryParams.toString()}`
    );
    return response.data;
  },

  // Toggle automation status
  toggleAutomationStatus: async (
    automationUuid: string,
    isActive: boolean
  ): Promise<void> => {
    await userAutomationsApi.patch(`/user/automations/${automationUuid}`, {
      isActive,
    });
  },

  // Delete automation
  deleteAutomation: async (automationUuid: string): Promise<void> => {
    await userAutomationsApi.delete(`/user/automations/${automationUuid}`);
  },
};
